export interface PostCreate {
  id: string
  title: string
  description: string
  category: string
  price: number
  address: string
  rooms: number
  meters: number
  slug: string
  city: string
  zipCode: number
  tags: string[]
  postImages?: AddPhoto[]
  type: number
  country?: number
  currency?: number
}

export interface Post {
  id: string
  title: string
  description: string
  category: string
  slug: string
  price: number
  address: string
  rooms: number
  meters: number
  city: string
  zipCode: number
  userEmail?: string
  userId?: string
  userCompanyName: string
  userCompanyUrl: string
  tags: Tags[]
  type: number
  status: PostStatus
  country?: number
  currency?: number
  phoneNumber?: string
  postImages: PostImage[]
  convertedPrice?: any
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}

export interface Tags {
  id: string
  tag: string
}

export interface PostImage {
  id: string
  image: string
  primary: boolean
}

export interface AddPhoto {
  file: any
  primary: string
  id?: string
}

export enum PostStatus {
  Active = 0,
  Deleted = 1,
}
